module.exports = __webpack_public_path__ + "img/img3.487addd3.jpg";